export const queryKeys = {
    me: () => ["me"],
    health: () => ["health"],
    club: (clubId) => ["club", clubId],
    books: (clubId) => ["books", clubId],
    members: (clubId) => ["members", clubId],
    discussion: (clubId, bookId) => ["discussion", clubId, bookId],
    notifications: () => ["notifications"],
    notificationCount: () => ["notif-count"],
};
export function createHooks(api, rq) {
    const q = (queryKey, queryFn, defaults, o) => rq.useQuery({ queryKey, queryFn, ...defaults, ...o });
    /** A mutation that refreshes the given queries once it lands (before any onSuccess of the caller's). */
    function useWrite(fn, refresh, o) {
        const qc = rq.useQueryClient();
        return rq.useMutation({
            ...o, mutationFn: fn,
            onSuccess: async (data, v, ...rest) => {
                await Promise.all(refresh(v).map((queryKey) => qc.invalidateQueries({ queryKey })));
                await o?.onSuccess?.(data, v, ...rest);
            },
        });
    }
    return {
        useMe: (o) => q(queryKeys.me(), api.me, {}, o),
        useHealth: (o) => q(queryKeys.health(), api.health, { staleTime: 5 * 60_000 }, o),
        useClub: (clubId, o) => q(queryKeys.club(clubId), () => api.club(clubId), {}, o),
        useClubBooks: (clubId, o) => q(queryKeys.books(clubId), () => api.clubBooks(clubId), {}, o),
        useMembers: (clubId, o) => q(queryKeys.members(clubId), () => api.members(clubId), {}, o),
        useDiscussion: (clubId, bookId, o) => q(queryKeys.discussion(clubId, bookId), () => api.discussion(clubId, bookId), {}, o),
        useNotificationCount: (o) => q(queryKeys.notificationCount(), api.notificationCount, { refetchInterval: 60_000, refetchOnWindowFocus: true, staleTime: 15_000 }, o),
        useNotifications: () => rq.useInfiniteQuery({
            queryKey: queryKeys.notifications(), queryFn: ({ pageParam }) => api.notifications(pageParam),
            initialPageParam: null, getNextPageParam: (p) => p.next,
        }),
        /** Your progress on a book: refreshes the club's books and that book's discussion (what you can read changes). */
        useUpdateProgress: (clubId, bookId, o) => useWrite((v) => api.updateProgress(clubId, bookId, v), () => [queryKeys.books(clubId), queryKeys.discussion(clubId, bookId)], o),
        /** A message, reply, quote or question in Talk. */
        useAddComment: (clubId, bookId, o) => useWrite((v) => api.addComment(clubId, bookId, v), () => [queryKeys.discussion(clubId, bookId)], o),
        useEditComment: (clubId, bookId, o) => useWrite(({ id, ...v }) => api.editComment(clubId, id, v), () => [queryKeys.discussion(clubId, bookId)], o),
        useDeleteComment: (clubId, bookId, o) => useWrite((id) => api.deleteComment(clubId, id), () => [queryKeys.discussion(clubId, bookId)], o),
        useMarkRead: (o) => useWrite((v) => api.markRead(v), () => [queryKeys.notifications(), queryKeys.notificationCount()], o),
    };
}
//# sourceMappingURL=hooks.js.map